import { Card, CardBody } from "reactstrap"
import QuotationList from "./Quotation/QuotationList"
import QuotationHeader from "./Quotation/QuotationHeader"

export default function QuotationsTab({ customer, onChanged }) {
  const quotations = customer?.quotations || []
  const total = quotations.length ?? 0

  return (
    <Card className="border-0 shadow-sm">
      <CardBody className="p-4">
        <QuotationHeader total={total} customer={customer} />
        <QuotationList data={quotations} onChanged={onChanged} />
      </CardBody>
    </Card>
  )
}
